import { CONSTANTS } from '../../_data/lookups.js';
import { getStepAtCursor } from './getStepAtCursor.js';
export function resolveStepResolution(args) {
    const stepCursorResult = getStepAtCursor({
        nodeName: args.nodeName,
        currentThreadIndex: args.currentThreadIndex,
        currentStepCounter: args.currentStepCounter,
        threadSteps: args.threadSteps,
    });
    if (!stepCursorResult.ok) {
        return err(stepCursorResult.error);
    }
    return resolveStepResolutionByKind({
        nodeName: args.nodeName,
        step: stepCursorResult.value,
        toolMap: args.toolMap,
        ...(args.branchMode !== undefined ? { branchMode: args.branchMode } : {}),
    });
}
const err = (error) => ({ ok: false, error });
const ok = (value) => ({ ok: true, value });
const formatPrefix = (nodeName) => `[${nodeName}]`;
function resolveStepResolutionByKind(args) {
    const { nodeName, step, toolMap, } = args;
    switch (step.stepKind) {
        case CONSTANTS.Enums.StepKind.tool: {
            const toolStep = step;
            const tool = toolMap.get(toolStep.toolHandle);
            if (!tool) {
                return err({
                    code: 'missing_tool',
                    message: `${formatPrefix(nodeName)} Tool '${toolStep.toolHandle}' not found in toolMap`,
                    details: { toolHandle: toolStep.toolHandle },
                });
            }
            return ok({
                step: toolStep,
                tool: tool,
            });
        }
        case CONSTANTS.Enums.StepKind.for: {
            const forStep = step;
            const whatToolStep = forStep.case.what;
            const whenToolStep = forStep.case.when;
            const whatTool = toolMap.get(whatToolStep.toolHandle);
            const whenTool = toolMap.get(whenToolStep.toolHandle);
            if (!whatTool) {
                return err({
                    code: 'missing_tool',
                    message: `${formatPrefix(nodeName)} Tool '${whatToolStep.toolHandle}' not found in toolMap`,
                    details: { toolHandle: whatToolStep.toolHandle },
                });
            }
            if (!whenTool) {
                return err({
                    code: 'missing_tool',
                    message: `${formatPrefix(nodeName)} Tool '${whenToolStep.toolHandle}' not found in toolMap`,
                    details: { toolHandle: whenToolStep.toolHandle },
                });
            }
            return ok({
                step: forStep,
                resolvedCase: {
                    whatToolStep,
                    whatTool,
                    whenToolStep,
                    whenTool,
                },
            });
        }
        case CONSTANTS.Enums.StepKind.while: {
            const whileStep = step;
            const whatToolStep = whileStep.case.what;
            const whenToolStep = whileStep.case.when;
            const whatTool = toolMap.get(whatToolStep.toolHandle);
            const whenTool = toolMap.get(whenToolStep.toolHandle);
            if (!whatTool) {
                return err({
                    code: 'missing_tool',
                    message: `${formatPrefix(nodeName)} Tool '${whatToolStep.toolHandle}' not found in toolMap`,
                    details: { toolHandle: whatToolStep.toolHandle },
                });
            }
            if (!whenTool) {
                return err({
                    code: 'missing_tool',
                    message: `${formatPrefix(nodeName)} Tool '${whenToolStep.toolHandle}' not found in toolMap`,
                    details: { toolHandle: whenToolStep.toolHandle },
                });
            }
            return ok({
                step: whileStep,
                resolvedCase: {
                    whatToolStep,
                    whatTool,
                    whenToolStep,
                    whenTool,
                },
            });
        }
        case CONSTANTS.Enums.StepKind.branch: {
            const branchStep = step;
            const branchMode = args.branchMode ?? 'first';
            const resolvedCases = [];
            for (const [caseIndex, c] of branchStep.cases.entries()) {
                if (branchMode === 'first' && caseIndex > 0)
                    break;
                const whenToolStep = c.when;
                const whatToolStep = c.what;
                const whatTool = toolMap.get(whatToolStep.toolHandle);
                const whenTool = toolMap.get(whenToolStep.toolHandle);
                if (!whatTool) {
                    return err({
                        code: 'missing_tool',
                        message: `${formatPrefix(nodeName)} Tool '${whatToolStep.toolHandle}' not found in toolMap`,
                        details: { toolHandle: whatToolStep.toolHandle },
                    });
                }
                if (!whenTool) {
                    return err({
                        code: 'missing_tool',
                        message: `${formatPrefix(nodeName)} Tool '${whenToolStep.toolHandle}' not found in toolMap`,
                        details: { toolHandle: whenToolStep.toolHandle },
                    });
                }
                resolvedCases.push({
                    caseIndex,
                    whenToolStep,
                    whenTool,
                    whatToolStep,
                    whatTool,
                });
            }
            return ok({
                step: branchStep,
                resolvedCases: resolvedCases,
            });
        }
    }
}
